import React, { FC, useState, MouseEvent } from 'react'
import i18n from 'i18next'
import { IonAlert } from '@ionic/react'
import { ICard } from '@mobx/pay/pay.mobx'
import { maskBankCardNumber } from '../util'

interface ICardItemProps {
  card: ICard;
  isCurrent?: boolean;
  disabled?: boolean;
  onSelect?(): void;
  onDelete?(): void;
}

const CardItem: FC<ICardItemProps> = ({ card, isCurrent, disabled, onSelect, onDelete }) => {
  const [showDeleteAlert, setShowDeleteAlert] = useState(false)

  const onDeleteClick = (e: MouseEvent) => {
    e.stopPropagation()
    setShowDeleteAlert(true)
  }

  return (
    <>
      <li className={'bank-card' + (isCurrent ? ' current' : '')} onClick={onSelect}>
        {maskBankCardNumber(card.number)}
        <i className='iconfont icon-delete' onClick={onDeleteClick} />
      </li>
      <IonAlert
        isOpen={!!showDeleteAlert}
        message={i18n.t('pay.confirmDeleteBankCard')}
        buttons={[
          { text: i18n.t('common.cancel'), role: 'cancel', handler: () => setShowDeleteAlert(false) },
          { text: i18n.t('common.ok'), handler: () => onDelete() }
        ]}
      />
    </>
  )
}

export default CardItem
